export default "__VITE_ASSET__3a7be717__"